import "./ComplexDetail.css";
import { Grid } from "@mui/material";
import { useAlertContext, useRoleContext } from "src/hooks/use-alert";
import Image from "mui-image";
import BuildingForm from "src/components/BuildingDetails/BuildingForm";
import SiteForm from "src/components/SiteMonitor/SiteForm";
import complexMap from "src/img/complexx.png";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useNavigate } from "react-router-dom";
import { Suspense } from "react";
import { useRouteLoaderData, defer, Await } from "react-router-dom";
import { getSite, deleteBuilding } from "src/apis/complex";
import { useState, useEffect } from "react";
import DailogContainer from "src/components/DailogContainer";
import { loadFloorImg } from 'src/apis/Archilogic.js'
import { addLoader } from 'src/apis/loader.js'
import ErrorPage from "src/pages/ErrorPages/ErrorPage";
export default function Complex() {
  const { roles } = useRoleContext();
  const data = useRouteLoaderData("complex-detail");
  const alert = useAlertContext();
  const navigate = useNavigate();
  const [modal, setModal] = useState({ open: false, formElement: "site" });
  const [externalSubmit, setExternalSubmit] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [deleteDetailOpen, setDeleteDetailOpen] = useState(false);
  const [deleteBuildingInfo, setDeleteBuildingInfo] = useState("");
  const [deleteText, setDeleteText] = useState("");
  useEffect(() => {
    // Set the initial list of buildings when the component mounts
    if (data.complex && data.complex.buildings) {
      setBuildings(data.complex.buildings);
    }
    

  }, [data.complex]);

  const handleExternalSubmit = (submitting, closeModal = false) => {
    if (submitting) {
      setExternalSubmit(true);
    } else {
      if (closeModal) {
        handleClose();
        navigate();
      }
      setExternalSubmit(false);
    }
  };

  const handleClickOpen = (form) => {
    setModal({ open: true, formElement: form });
  };

  const handleClose = () => {
    setModal({ open: false, formElement: null });
  };

  const handleDelete = (building) => {
    console.log(building, "Buildings");
    if (building.assets.length > 0) {
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          message:
            "Cannot delete " +
            building.name +
            " because it has " +
            building.assets.length +
            " assets in it.",
        },
      ]);
    } else {
      setDeleteDetailOpen(true);
      setDeleteBuildingInfo(building.id);
      setDeleteText("Are you sure you want to delete this building?");
    }
  };

  // Callback function to confirm the delete in child component
  const handleConfirmChange = () => {
    handleConfirmDelete();
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await deleteBuilding(deleteBuildingInfo);
      if (response.success) {
        console.log("delete is done");

        // Remove the deleted building from the buildings state
        setBuildings((prevBuildings) =>
          prevBuildings.filter((building) => building.id !== deleteBuildingInfo)
        );

        alert.setSuccess((prev) => [
          ...prev,
          {
            status: true,
            message: "Building deleted succesfully",
            index: prev.length,
          },
        ]);
      } else {
        alert.setError((prev) => [
          ...prev,
          { status: true, messages: response.errors, index: prev.length },
        ]);
      }
    } catch (error) {
      console.error("Error deleting building:", error);
      alert.setError((prev) => [
        ...prev,
        {
          status: true,
          messages: ["Error deleting building"],
          index: prev.length,
        },
      ]);
    } finally {
      // Whether the deletion succeeded or failed, you can set externalSubmit to false here
      setExternalSubmit(false);
    }
    setDeleteDetailOpen(false);
  };

  return (
    <Suspense
      fallback={
        <p style={{ color: "#FFF", textAlign: "center" }}>Loading...</p>
      }
    >
      <Await resolve={data.complex} errorElement={<ErrorPage />}>
        {(loadedComplex) => (
          <>
          {loadedComplex ? (
          <div>
            <div className="started">
              <h2>{loadedComplex.name}</h2>
            </div>
            <div className="directory">Inventory : {loadedComplex.name}</div>
            <div className="homeContainerComplex">
              <Grid container>
                <Grid item lg={2} md={2} xs={1}>
                  <Grid container>
                    <div className="buildInfo">
                      <div className="buildImage">
                        <Image src={complexMap} width={180} />
                      
                      </div>
                    </div>
                  </Grid>
                </Grid>
                <Grid item lg={10} md={10} sm={11} xs={11}>
                  <div className="complexInfo">
                    <Grid container>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <div className="infoTitle">
                          <h2>Info</h2>
                        </div>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <div className="infoButton">
                          <ButtonPolicy
                            onClick={() => {
                              console.log(roles.roles);
                              handleClickOpen("site");
                            }}
                            variant="contained"
                            sx={{
                              width: 150,
                              borderRadius: "0",
                            }}
                          >
                            Update Site
                          </ButtonPolicy>
                        </div>
                      </Grid>
                      <Grid item md={12} lg={12} sm={12} xs={12}>
                        <div className="description">
                          <Grid container>
                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Name: </span>
                                {loadedComplex.name}
                              </div>
                            </Grid>

                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">
                                  Phone Number:{" "}
                                </span>
                                {loadedComplex.phoneNumber}
                              </div>
                            </Grid>
                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Cell Number: </span>
                                {loadedComplex.cellNumber}
                              </div>
                            </Grid>
                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Address: </span>
                                {loadedComplex.address}
                              </div>
                            </Grid>
                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <div className="detailsItem">
                                <span className="titleItem">Email: </span>
                                {loadedComplex.email}
                              </div>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <div className="detailsItem desc">
                                <span className="titleItem">Description:</span>
                                <div className="description-details">
                                  {loadedComplex.description}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="buildings">
                    <Grid container>
                      <Grid item md={6} lg={6} xs={6} sm={6}>
                        <div className="infoTitle">
                          <h2>Buildings</h2>
                        </div>
                      </Grid>
                      <Grid item md={6} lg={6} xs={6} sm={6}>
                        <div className="infoButton">
                          <ButtonPolicy
                            onClick={() => handleClickOpen("building")}
                            variant="contained"
                            sx={{
                              width: 150,
                              borderRadius: "0",
                            }}
                          >
                            Add Building
                          </ButtonPolicy>
                        </div>
                      </Grid>
                      <Grid item md={12} lg={12} sm={12} xs={12}>
                        <div className="tableContainer">
                          <TableContainer component={Paper}>
                            <Table>
                              <TableBody>
                                {buildings && buildings.length>0 && buildings.map((row) => (
                                  <TableRow key={row.id}>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.address}</TableCell>
                                    <TableCell>
                                      <div className="viewMore">
                                        <ButtonPolicy
                                          onClick={() =>
                                            navigate(`building/${row.id}`)
                                          }
                                          variant="contained"
                                          color="primary"
                                        >
                                          View More
                                        </ButtonPolicy>
                                      </div>
                                    </TableCell>
                                    <TableCell>
                                      <div className="deleteButton">
                                        <ButtonPolicy
                                          variant="contained"
                                          color="secondary"
                                          onClick={() => handleDelete(row)}
                                        >
                                          <DeleteIcon />
                                        </ButtonPolicy>
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
              <Dialog open={modal.open} onClose={handleClose}>
                <div className="modalContainer">
                  <div className="modal">
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12} lg={12} sm={12}>
                        <DialogContent>
                          <Grid container>
                            {modal.formElement === "building" ? (
                              <BuildingForm
                                props={{
                                  custom: true,
                                  onSubmit: handleExternalSubmit,
                                  externalSubmit: externalSubmit,
                                  siteData: {
                                    id: loadedComplex.id,
                                    name: loadedComplex.name,
                                  },
                                }}
                              />
                            ) : (
                              <SiteForm
                                props={{
                                  custom: true,
                                  onSubmit: handleExternalSubmit,
                                  externalSubmit: externalSubmit,
                                  site: loadedComplex,
                                }}
                              />
                            )}
                          </Grid>
                        </DialogContent>
                      </Grid>
                      <Grid item md={12} xs={12} lg={12}>
                        <div className="bottomPart">
                          <DialogActions>
                            <Grid container>
                              <Grid item xs={6} md={6} lg={6}>
                                <div className="cancelUPdateBuilding">
                                  <ButtonPolicy
                                  className="cancelUPdateBuilding"
                                    onClick={() => handleClose()}
                                    variant="text"
                                  >
                                    Cancel
                                  </ButtonPolicy>
                                </div>
                              </Grid>
                              <Grid item xs={6} md={6} lg={6}>
                                <div className="addButton">
                                  <ButtonPolicy
                                    variant="text"
                                    onClick={() => handleExternalSubmit(true)}
                                  >
                                    {/* <ButtonPolicy variant="text"> */}
                                    submit
                                  </ButtonPolicy>
                                </div>
                              </Grid>
                            </Grid>
                          </DialogActions>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Dialog>
            </div>
            {deleteDetailOpen && (
              <DailogContainer
                detailOpen={deleteDetailOpen}
                setDetailOpen={setDeleteDetailOpen}
                text={deleteText}
                onToggleChange={handleConfirmChange}
              />
            )}
          </div>
          ):(
        <ErrorPage />
      )}
          </>
        )}
      </Await>
    </Suspense>
  );
}

async function loadComplex(id) {
  const response = await getSite(id);
  return response;
}

export async function loader({ request, params }) {
  const id = params.complexId;

  return defer({
    complex: await loadComplex(id),
  });
}
